import React from "react";
import { Carousel } from "react-bootstrap";
import "./Carousal.css"; // Make sure this file exists

const Banner1 = "/Banner/Banner-01.png"
const Banner2 = "/Banner/Banner-02.png"; 

function MyCarousel() {
  return (
    <div className="carousel-container">
      <Carousel>
        <Carousel.Item>
          <img
           className="my-banner-img"
            src={Banner1}
            alt="Shipment Solutions Banner"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
          className="my-banner-img"
            src={Banner2}
            alt="Shipment Solutions Banner"
          />
        </Carousel.Item>
        {/* <Carousel.Item>
          <img
           className="my-banner-img"
            src={Banner}
            alt="Shipment Solutions Banner"
          />
        </Carousel.Item> */}
      </Carousel>
    </div>
  );
}

export default MyCarousel;
